import React from 'react'
import CustomIconBase from './CustomIconBase'

export const SearchMenuIcon = ({ fill, ...props }) => (
  <CustomIconBase viewBox='0 0 26 18' {...props}>
    <path
      fillRule='evenodd'
      d='M6.22222 10.4444C8.55409 10.4444 10.4444 8.55409 10.4444 6.22222C10.4444 3.89035 8.55409 2 6.22222 2C3.89035 2 2 3.89035 2 6.22222C2 8.55409 3.89035 10.4444 6.22222 10.4444ZM6.22222 12.4444C9.65866 12.4444 12.4444 9.65866 12.4444 6.22222C12.4444 2.78578 9.65866 0 6.22222 0C2.78578 0 0 2.78578 0 6.22222C0 9.65866 2.78578 12.4444 6.22222 12.4444Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      d='M8.92868 9.57158C9.37051 9.24021 9.99155 9.32207 10.3158 9.75442L15.0129 16.0172C15.3371 16.4495 15.2418 17.0686 14.8 17.4C14.3582 17.7314 13.7371 17.6495 13.4129 17.2172L8.71582 10.9544C8.39155 10.5221 8.48686 9.90295 8.92868 9.57158Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      d='M14 1C14 0.447715 14.4477 0 15 0H25C25.5523 0 26 0.447715 26 1C26 1.55228 25.5523 2 25 2H15C14.4477 2 14 1.55228 14 1Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      d='M16 7C16 6.44772 16.4477 6 17 6L25 6C25.5523 6 26 6.44772 26 7C26 7.55228 25.5523 8 25 8L17 8C16.4477 8 16 7.55228 16 7Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      d='M18 13C18 12.4477 18.4477 12 19 12L25 12C25.5523 12 26 12.4477 26 13C26 13.5523 25.5523 14 25 14L19 14C18.4477 14 18 13.5523 18 13Z'
      fill={fill}
    />
  </CustomIconBase>
)
